import { RootState } from "store/store";

export const selectStates = (state: RootState) => state.state.states;
export const selectCounties = (state: RootState) => state.state.counties;
export const selectCities = (state: RootState) => state.state.cities;
export const selectGeolocation = (state: RootState) => state.state.geolocation;
